import { Suspense, useEffect, useState } from "react";
import { Route, Router, Switch } from "react-router-dom";
import CommunityMembersBulkActionPage, {
  COMMUNITY_MEMBERS_BULK_ACTION_PAGE_ROUTE,
} from "./comunity-members-bulk-action.page";

import moment from "moment";
import { connect } from "react-redux";
import { Loader } from "../../_components/loader.component";
import LoginRequiredView from "../../_components/login-required-view.component";
import { history } from "../../_config";
import { CommunityPlanAccessService } from "../../_service/community-plan-access.service";
import { LeaderboardPage, LEADERBOARD_PAGE_ROUTE } from "../leaderboard.page";
import BulkMailPage, { BULK_MAIL_PAGE_ROUTE } from "./bulk-mail";
import CustomPushPage, { CUSTOM_PUSH_PAGE_ROUTE } from "./custom-push";
import InviteMembersSettingsPage, {
  INVITE_MEMBERS_SETTINGS_PAGE_ROUTE,
} from "./invite-user-settings.page";
import SubscriptionsPage, {
  SUBSCRIPTION_PAGE_ROUTE,
} from "./subscriptions/subscriptions-list/subscriptions-page";
import CommunitySettingSidebarComponent from "./user-management-sidebar.component";

export const USERS_MANAGEMENT_SETTINGS_PAGE_ROUTE = "/settings/members";

function UserManagementComponent({ user, community, groups }) {
  const communityId = community?.id;

  const [monthlyLimit, setMonthlyLimit] = useState(null);
  const [monthlyLimitReset, setMonthlyLimitReset] = useState(null);
  const [dailyLimit, setDailyLimit] = useState(null);
  const [dailyLimitReset, setDailyLimitReset] = useState(null);

  // get remaining email count
  useEffect(() => {
    CommunityPlanAccessService.getRemainingEmailCount(communityId).then(
      (remainingEmailCount) => {
        setMonthlyLimit(remainingEmailCount.monthlyLimit);
        setDailyLimit(remainingEmailCount.dailyLimit);
        setMonthlyLimitReset(
          moment(remainingEmailCount.monthlyLimitReset)
            .format("DD MMM YYYY hh:mm A")
            .toString()
        );
        setDailyLimitReset(
          moment(remainingEmailCount.dailyLimitReset)
            .format("hh:mm A")
            .toString()
        );
      }
    );
  }, [communityId]);

  if (!user) {
    return <LoginRequiredView />;
  } else if (community && community.myRole !== "admin") {
    if (community.myRole === null || community.myRole === undefined) {
      return <></>;
    }
    return (
      <div className="UserWallPage flex flex-col items-center justify-center">
        <div className="text-center my-5 theme-text-subtitle-1">
          No page found
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="UserManagementPage ">
        <div className="sidebar_left">
          <CommunitySettingSidebarComponent />
        </div>

        <div className="main">
          <Router history={history}>
            <Switch>
              <Route path={LEADERBOARD_PAGE_ROUTE} exact>
                <Suspense fallback={<Loader />}>
                  <LeaderboardPage fullHeight={false} />
                </Suspense>
              </Route>
              <Route path={COMMUNITY_MEMBERS_BULK_ACTION_PAGE_ROUTE} exact>
                <Suspense fallback={<Loader />}>
                  <CommunityMembersBulkActionPage />
                </Suspense>
              </Route>
              <Route path={INVITE_MEMBERS_SETTINGS_PAGE_ROUTE} exact>
                <Suspense fallback={<Loader />}>
                  <InviteMembersSettingsPage
                    dailyLimit={dailyLimit}
                    dailyLimitReset={dailyLimitReset}
                  />
                </Suspense>
              </Route>
              <Route path={BULK_MAIL_PAGE_ROUTE} exact>
                <Suspense fallback={<Loader />}>
                  <BulkMailPage
                    monthlyLimit={monthlyLimit}
                    monthlyLimitReset={monthlyLimitReset}
                  />
                </Suspense>
              </Route>
              <Route path={SUBSCRIPTION_PAGE_ROUTE} exact>
                <Suspense fallback={<Loader />}>
                  <SubscriptionsPage />
                </Suspense>
              </Route>
              <Route path={CUSTOM_PUSH_PAGE_ROUTE} exact>
                <Suspense fallback={<Loader />}>
                  <CustomPushPage
                    monthlyLimit={monthlyLimit}
                    monthlyLimitReset={monthlyLimitReset}
                  />
                </Suspense>
              </Route>
            </Switch>
          </Router>
        </div>
      </div>
    </div>
  );
}
const msp = (s) => ({ user: s.auth, community: s.community, groups: s.groups });
export default connect(msp)(UserManagementComponent);
